import React from 'react';
import { useTranslation } from 'react-i18next';
import { KpiHeroBlock } from '../public_reports/blocks/KpiHeroBlock';
import { MetricCardBlock } from '../public_reports/blocks/MetricCardBlock';
import { LineChartBlock } from '../public_reports/blocks/LineChartBlock';
import { BarChartBlock } from '../public_reports/blocks/BarChartBlock';
import { TableBlock } from '../public_reports/blocks/TableBlock';

const BLOCK_COMPONENTS = {
    kpi_hero: KpiHeroBlock,
    metric_card: MetricCardBlock,
    line_chart: LineChartBlock,
    bar_chart: BarChartBlock,
    table: TableBlock,
};

export function ChatBlock({ blockType, data }) {
    const { t } = useTranslation();

    const Component = BLOCK_COMPONENTS[blockType];

    if (!Component) {
        return (
            <div className={`chat-block chat-block--unknown`}>
                <span className="chat-block__fallback">
                    {t('agent_chat.unknown_block', { type: blockType })}
                </span>
            </div>
        );
    }

    const title = data?.title;

    return (
        <div className={`chat-block chat-block--${blockType}`}>
            {title && <div className="chat-block__title">{title}</div>}
            <Component data={data} />
        </div>
    );
}
